import { useState, useCallback, useEffect } from 'react'; //2025.08 COMTEC kawaji MOD --useEffect追加
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';

import { usePageNavigate } from './usePageNavigate';
import { sendMailToTeikihoanURL } from '../logics/apiLogic';
import { Job } from '../types/teikihoan/commonDefinition';

type InputItems = {
  label: string;
  name: 'lastName' | 'firstName' | 'mailAddress' | 'mailAddress2';
  type: string;
  colSpan?: number;
};

type InputProps = {
  firstName: string;
  lastName: string;
  mailAddress: string;
  mailAddress2: string;
};

export const useMail = () => {
  const {
    register,
    formState: { isValid, errors },
    getValues,
    setError,
    clearErrors,
  } = useForm<InputProps>({
    // modeの変更
    mode: 'onChange',
  });
  const { menuPage } = usePageNavigate();
  const location = useLocation();
  const params = location.state;
  const [errMsg, setErrMsg] = useState<string>('');
  const [inputMailAddress, setInputMailAddress] = useState<string>('');
  const [currentStep, setCurrentStep] = useState(0);
  const [isShowMoveButton, setIsShowMoveButton] = useState<boolean>(false); //2025.08 COMTEC kawaji ADD

  /****************************************
   * 入力項目
   ****************************************/
  const inputItems: InputItems[] = [
    { label: '姓', name: 'lastName', type: 'text' },
    { label: '名', name: 'firstName', type: 'text' },
    { label: 'メールアドレス', name: 'mailAddress', type: 'email', colSpan: 2 },
    {
      label: 'メールアドレス（確認）',
      name: 'mailAddress2',
      type: 'email',
      colSpan: 2,
    },
  ];

  /****************************************
   * メールが届かない時の対処
   ****************************************/
  const ngMailManuals = [
    'ご入力されたメールアドレスが間違っている。',
    '迷惑メール受信拒否設定によりブロックされている。\n「＠nihongas.co.jp」のドメインを受信可能に設定してください。',
    '迷惑メールやプロモーションのフォルダに自動で振り分けされている。',
  ];

  // 2025.08 COMTEC kawaji ADD START
  useEffect(() => {
    //”お客さまサポートトップ”のボタンの表示非表示判定
    setIsShowMoveButton(params.gyomu === Job.Teikihoan);
  }, []);
  // 2025.08 COMTEC kawaji ADD END

  /****************************************
   * メールアドレスの送信処理
   ****************************************/
  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      // パラメータ作成
      const { firstName, lastName, mailAddress } = getValues();
      const param = {
        mail_address: mailAddress,
        last_name: lastName,
        first_name: firstName,
        source_cd: params.source,
        shubetsu_name: params.gyomu,
      };
      //メール送信
      const result = await sendMailToTeikihoanURL(param);
      if (result.result === 0) {
        setInputMailAddress(mailAddress);
        setCurrentStep((currentStep) => currentStep + 1);
      } else if (result.result === 9) {
        setErrMsg(result.error_message);
      } else {
        setErrMsg('メールの送信に失敗しました。');
      }
    },
    [getValues, params, setCurrentStep, setErrMsg, setInputMailAddress]
  );

  /****************************************
   * 戻るボタン処理
   ****************************************/
  const handleBack = useCallback(() => {
    menuPage(params);
  }, [menuPage, params]);

  /****************************************
   * 日本ガスホームページに移動する
   ****************************************/
  const MoveToHp = useCallback(() => {
    const url = process.env.REACT_APP_CUSTOMER_SUPPORT_URL as string;
    window.location.replace(url);
  }, []);

  return {
    inputItems,
    ngMailManuals,
    errMsg,
    isValid,
    errors,
    inputMailAddress,
    currentStep,
    isShowMoveButton, //2025.08 COMTEC kawaji ADD
    handleSubmit,
    handleBack,
    register,
    setError,
    clearErrors,
    getValues,
    MoveToHp,
  };
};
